class Errors {
  constructor() {
    this.errors = {}
  }

  has(field) {
    if (this.errors[field]) {
      return true
    }
    return false
  }

  get(field) {
    if (this.errors[field]) {
      return this.errors[field][0]
    }
  }

  record(errors) {
    this.errors = errors
  }

  clear(field) {
    if (this.errors[field]) {
      delete this.errors[field]
    }
  }

  clears() {
    this.errors = {}
  }
}

export default Errors
